import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {onBeforeRouteUpdate} from "vue-router";
import {onMounted, reactive, ref, watch} from "vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import {ColumnModel} from "@syncfusion/ej2-grids/src/grid/models/column";
import {BooleanColumn, DefaultColumn} from "@/shared/ui/types/SogGridColumnDefinitions";
import SogGrid from "@/shared/ui/SogGrid.vue";
import {useAccountStore} from "@/stores/accountStore";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {Action, lossAdjusterActions, superActions, usNatoActions} from "@/shared/model/Action";
import notificationService from "@/shared/services/NotificationService";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import PersonIds from "@/shared/model/PersonIds";
import {useSpinner} from "@/shared/composables/SogSpinner";

interface Props {
  personId?: string
  actions?: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PermissionComponent',
  props: {
    personId: { default: undefined },
    actions: { default: undefined }
  },
  setup(__props: any) {

const props = __props

const _columns: ColumnModel[] = [
  /*
  { type: 'checkbox' },
*/
  {...DefaultColumn, field: 'id', headerText: 'id', isPrimaryKey: true, visible: false},
  {...BooleanColumn, field: 'checked', headerText: ''},
  {...DefaultColumn, field: 'description', headerText: 'Berechtigung'},
]


const _data = reactive<{ id: string, checked: boolean, description: string }[]>([])
const _accountStore = useAccountStore();
const _grid = ref<InstanceType<typeof SogGrid> | null>(null)
const _edit = ref(false)
const _spinner = useSpinner()


watch(props, () => {
  init();

  /*
    const array = _accountStore.getManagedActions().map(t=>{
      const checked = props.actions ? props.actions.some(a=>a.toLowerCase()===t.id.toLowerCase()):false;
      const a = {...t,checked : checked}
      return a;
    })
    _data.push(...array)
    _grid.value?.refresh();
  */

}, {immediate: true})

function init() {
  _data.length = 0;

  let array = _accountStore.getManagedActions();

  if (_accountStore.hasAction(Action.SuperAccountManage) || _accountStore.actionPerson?.id === "person_getmann") {
    array.push(...superActions)
  }


  if (props.personId === PersonIds.UsNato || _accountStore.person?.id === PersonIds.UsNato)
    array = [...usNatoActions];

  if (_accountStore.person?.isLossAdjuster())
    array = [...lossAdjusterActions];

  array = array.map(t => {
    const checked = props.actions ? props.actions.some(a => a.toLowerCase() === t.id.toLowerCase()) : false;
    return {...t, checked: checked};
  })
  _data.push(...array)
  _grid.value?.refresh();
}

onMounted(async () => {
  await init();
})


onBeforeRouteUpdate(async () => {
  await init();
})

function onEdit() {
  if (!props.personId) {
    notificationService.error("Person ist unbekannt")
    return;
  }
  if (!_accountStore.hasAction(Action.AccountManage)) {
    notificationService.error("Sie haben nicht die notwendige Brechtigungen")
    return;
  }
  _edit.value = true
}

function onCancel() {
  _edit.value = false
  init();
}

async function onSave() {
  try {
    _spinner.show()
    const actions = _data.filter(t => t.checked).map(t => t.id)
    const res = await apiOrganisationStructure.accountChangeActions(props.personId ?? "", actions)
    if (res) {
      _spinner.hide()
      notificationService.success("Berechtigungen wurde zugeteilt")
      _edit.value = false
    }
  } finally {
    _spinner.hide()
  }
}

function onRowSelected(args: any) {
  const i = _data.findIndex((t) => {
    return t.id === args.data.id
  })
  _data[i].checked = !_data[i].checked;
  _grid.value.refresh();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Berechtigungen", -1)
        ]))]),
        _: 1
      }),
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SogGrid, {
            ref_key: "_grid",
            ref: _grid,
            data: _data,
            columns: _columns,
            "allow-paging": "false",
            "hide-scroll": "true",
            "on-row-selected": onRowSelected,
            "allow-selection": _edit.value
          }, null, 8, ["data", "allow-selection"])
        ]),
        _: 1
      }),
      _createVNode(SogCardActions, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-pencil",
            onClick: onEdit
          }, null, 512), [
            [_vShow, !_edit.value]
          ]),
          _withDirectives(_createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-content-save",
            onClick: onSave
          }, null, 512), [
            [_vShow, _edit.value]
          ]),
          _withDirectives(_createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-cancel",
            onClick: onCancel
          }, null, 512), [
            [_vShow, _edit.value]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})